document.cookie = 'post-protection=1; expires=' + (new Date(new Date().getTime() + (86400 * 7 * 1000))).toGMTString() + '; path=/; secure; samesite=none';

(function () {
	if ($('#changeCustomer').length) {
		const customers = $('#changeCustomer').data("options").split(',');
		// const customers = ['návštěvníka', 'fanouška', 'posluchače', 'pořadatele'];
		let i = 0;
		setInterval(function () {
			$('#changeCustomer').fadeOut(function () {
				$(this).html(customers[i = (i + 1) % customers.length]).fadeIn();
			});
		}, 3000);
	}
})();

$(document).ready(function () {

	feather.replace()

	// FLASH & LANG PANEL

	// FLASH
	const flashes = $('.flash');

	if (flashes.length > 1) {
		flashes.forEach(flash => {
			setTimeout(() => flash.css('opacity', 0), 5000);
			setTimeout(() => {
				flash.css('display', 'none');
			}, 5500);
		});
	}
	else {
		setTimeout(() => flashes.css('opacity', 0), 5000);
		setTimeout(() => {
			flashes.css('display', 'none');
		}, 5500);
	}

	// LANG PANEL
	let langHeight = $('.language-panel').height();

	window.onresize = () => {
		langHeight = $('.language-panel').height();
		$('.lang-bar-padding').css('padding-top', langHeight);
	}

	$('.lang-bar-padding').css('padding-top', langHeight);

	// NAVBAR
	const nav = document.getElementsByTagName('nav')[0];
	const menuBtn = document.getElementById('menu-btn');
	const menuIcon = document.getElementById('menu-icon');

	const mobileNav = document.getElementById('mobile-nav');
	const mobileNavItem = document.querySelectorAll('.mobile-nav-item');
	const mobileNavLangItem = document.querySelector('.mobile-nav-lang-item');

	const mobileNavSubItem = document.querySelector('.mobile-nav-sub-item');
	const mobileNavLangSubItem = document.querySelector('.mobile-nav-lang-sub-item');

	window.onscroll = () => {
		if (document.body.scrollTop > 250 || document.documentElement.scrollTop > 250) {
			nav.classList.add('bg-enigoo-tertiary');
		}
		else {
			nav.classList.remove('bg-enigoo-tertiary');
		}
	}

	menuBtn.onclick = () => {
		nav.classList.toggle('show-mobile-nav');
		menuIcon.children[0].classList.toggle('first');
		menuIcon.children[1].classList.toggle('second');

		mobileNav.classList.toggle('hidden');
	}

	mobileNavItem.forEach(item => {
		if (item.children.length > 0) {
			item.onclick = () => {
				mobileNavSubItem.classList.toggle('hidden');
			}
		}
	})

	if (mobileNavLangItem.children.length > 0) {
		mobileNavLangItem.onclick = () => {
			mobileNavLangSubItem.classList.toggle('hidden');
		}
	}

	// OPEN POPUP
	$('.open-popup').click((event) => {
		window.open(event.currentTarget.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');

		return false;
	});

	// FOOTER
	const footerSection = document.querySelectorAll('.footer-section');
	footerSection.forEach(item => {
		const header = item.children[0];
		const list = item.children[1];

		header.onclick = () => {
			header.classList.toggle('footer-rotated');
			list.classList.toggle('footer-display');
		};
	});

	// OWL CAROUSEL
	$('.owl-carousel').owlCarousel({
		autoplay:           true,
		autoplayTimeout:    5000,
		autoplayHoverPause: true,
		center:             true,
		items:              1,
		loop:               true,
		margin:             10,

		responsive: {
			1024: {
				items: 1.2
			},
			1536: {
				items: 1.3
			},
			2000: {
				items: 1.5
			},
			2200: {
				items: 1.7
			}
		}
	});
});

// REVIEW
$(function () {
	console.log('script loaded');

	$(document).on('click', '.rate-star', function (e) {
		e.preventDefault();

		console.log('clicked rate star');

		$.get($(this).data('ajax-action'), function (data) {
			console.log('response:', data);

			if (data.snippets) {
				Object.keys(data.snippets).forEach(function (key) {
					console.log('updating #' + key);
					$('#' + key).html(data.snippets[key]);
				});
			} else {
				console.log('No snippets returned!');
			}
		});
	});
});
